import { Form, Input, Select } from "antd";
import { FormInstance } from "antd/es/form";
import * as React from "react";
import {
  ZSpecCategoryOption,
  ZSpecification,
  ZSpecificationCard,
} from "src/business/specification";
import { specCategoryOptions } from "src/business/specification/specCategoryOptions";
import { maxNameLength, rxName, rxNameMsg } from "src/common/rxName";
import { IdBox } from "src/components/IdBox";
import * as layoutStyles from "src/pages/management/objects/common/ObjectCardLayout.module.less";

import { AttrsListEditor } from "../AttrsListEditor";
import { SpecEditorVerSwitch } from "../SpecEditorVerSwitch";
import { ManagementSpecCommonCardStore } from "./ManagementSpecCommonCardStore";

const field = (key: keyof ZSpecificationCard): string => key;

type PropsManagementSpecCommonCardForm = {
  form: FormInstance;
  srcData: ZSpecification;
  pageStore: ManagementSpecCommonCardStore;
  onFinish: (values: unknown) => void;
};

export const ManagementSpecCommonCardForm: React.FC<
  PropsManagementSpecCommonCardForm
> = (props) => {
  const { form, srcData, pageStore, onFinish } = props;
  const { initialData } = pageStore;
  React.useEffect(() => {
    form.resetFields();
    form.setFieldsValue(initialData);
  }, [JSON.stringify(initialData)]);

  return (
    <Form<ZSpecificationCard>
      form={form}
      layout="vertical"
      className={layoutStyles.formColumnRoot}
      onFinish={onFinish}
      onFinishFailed={() => pageStore.setActiveTab("general")}
      initialValues={initialData}
      onValuesChange={(_, values) => {
        pageStore.onChange(values);
      }}
    >
      <div className={layoutStyles.fieldsHost}>
        <SpecEditorVerSwitch store={pageStore} />
        <div className={layoutStyles.fieldsStack}>
          <Form.Item
            name={field("name")}
            label="Системное название"
            rules={[
              { required: true },
              { pattern: rxName, message: rxNameMsg() },
              { max: maxNameLength },
            ]}
            tooltip="Системные названия любых спецификаций не должны совпадать"
          >
            <Input
              allowClear
              disabled={!pageStore.isNew}
              maxLength={maxNameLength}
            />
          </Form.Item>
          <IdBox entity={srcData} />
          <Form.Item
            name={field("displayName")}
            label="Название"
            rules={[{ max: maxNameLength }]}
          >
            <Input allowClear maxLength={maxNameLength} />
          </Form.Item>
          <Form.Item name={field("description")} label="Описание">
            <Input.TextArea allowClear />
          </Form.Item>
          <Form.Item name={field("categoryDataCode")} label="Категория данных">
            <Select<Number, ZSpecCategoryOption>
              fieldNames={{
                value: "code",
              }}
              options={specCategoryOptions}
            />
          </Form.Item>
          <AttrsListEditor
            name={["definition", "attributes"]}
            attrFeatures={pageStore.attrFeatures}
          />
        </div>
      </div>
    </Form>
  );
};
